import { Link } from 'react-router-dom';

const values = [
  { icon: 'ri-shield-check-line', title: 'Uncompromising Quality', desc: 'Every product undergoes rigorous quality control before leaving our facility.' },
  { icon: 'ri-tools-line', title: 'Precision Engineering', desc: 'Designed by professionals, for professionals. Every pocket, zipper, and stitch is intentional.' },
  { icon: 'ri-global-line', title: 'Global Reach', desc: 'Trusted by professionals in over 50 countries across 6 continents.' },
  { icon: 'ri-leaf-line', title: 'Sustainable Practices', desc: 'Committed to responsible manufacturing with eco-conscious materials and processes.' },
];

export default function BrandPreview() {
  return (
    <section className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
          {/* Left: Text */}
          <div>
            <span className="text-amber-600 text-xs font-semibold tracking-widest uppercase mb-4 block">About Yunxin</span>
            <h2 className="text-4xl md:text-5xl font-bold text-stone-900 leading-tight mb-6">
              Crafting Excellence<br />Since Establishment
            </h2>
            <p className="text-stone-500 text-base leading-relaxed mb-6">
              Quanzhou Yunxin Outdoor Products Co., Ltd. is a leading manufacturer of premium tool bags and organizer bags based in Fujian, China. With over 15 years of manufacturing expertise, we combine traditional craftsmanship with modern innovation.
            </p>
            <p className="text-stone-500 text-base leading-relaxed mb-10">
              Our state-of-the-art facility in Nan&apos;an City produces over 200 product models, serving professional markets worldwide with unmatched quality and reliability.
            </p>
            <Link
              to="/about"
              className="inline-flex items-center gap-2 bg-stone-900 hover:bg-stone-700 text-white px-8 py-4 rounded-full text-sm font-semibold tracking-widest uppercase transition-all duration-300 whitespace-nowrap cursor-pointer"
            >
              Learn More About Us
              <div className="w-4 h-4 flex items-center justify-center">
                <i className="ri-arrow-right-line" />
              </div>
            </Link>
          </div>

          {/* Right: Image + Values */}
          <div className="space-y-6">
            <div className="relative rounded-2xl overflow-hidden h-64">
              <img
                src="https://readdy.ai/api/search-image?query=modern%20bag%20manufacturing%20factory%20interior%20with%20workers%20and%20production%20line%20high%20quality%20facility%20Fujian%20China%20professional%20industrial%20photography&width=800&height=500&seq=brand1&orientation=landscape"
                alt="Yunxin Manufacturing Facility"
                className="w-full h-full object-cover object-top"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-stone-900/60 to-transparent" />
              <div className="absolute bottom-5 left-5">
                <p className="text-white font-semibold text-lg">Our Facility</p>
                <p className="text-white/70 text-sm">Nan&apos;an City, Fujian Province</p>
              </div>
            </div>

            <div className="grid grid-cols-2 gap-4">
              {values.map((v) => (
                <div key={v.title} className="bg-stone-50 rounded-xl p-5">
                  <div className="w-9 h-9 flex items-center justify-center bg-amber-100 rounded-lg mb-3">
                    <i className={`${v.icon} text-amber-700 text-lg`} />
                  </div>
                  <h4 className="text-stone-900 font-semibold text-sm mb-1">{v.title}</h4>
                  <p className="text-stone-500 text-xs leading-relaxed">{v.desc}</p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
